import "@/css/normalize.css";
import "@/css/firsStyle.css";
import "@/css/media.css";

import { createApp } from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import { createYmaps } from "vue-yandex-maps";
import { loadFonts } from "./plugins/webfontloader";
import router from "./router";

loadFonts();

createApp(App)
  .use(router)
  .use(vuetify)
  .use(
    createYmaps({
      apikey: "62c38567-1ac9-4e29-9411-2485e8ffca7d",
    })
  )
  .mount("#app");
